export enum LunchFlowSetupSteps {
  Intro = 'LunchFlowSetupSteps.Intro',
  Accounts = 'LunchFlowSetupSteps.Accounts',
  Sync = 'LunchFlowSetupSteps.Sync',
}
